import { QuickSearchCategory } from "./types";

export const ISSUE_TYPES = [
  "license",
  "malware",
  "secret",
  "violation",
  "vulnerability",
] as const;

export const UNSAVED_SEARCH = "Unsaved search";

export const INSIGHTS_SEARCH_SORT = {
  affected_packages: "Affected packages",
  affected_versions: "Affected versions",
  introduced: "Introduced",
  effort: "Effort",
};

export const QUICK_SEARCH_CATEGORY_LABEL: Record<QuickSearchCategory, string> =
  {
    hunting: "Hunting",
    licenses: "Licenses",
    malware: "Malware",
    secrets: "Secrets",
    tampering: "Tampering",
    vulnerabilities: "Vulnerabilities",
  };
